<template>
  <v-main>
    <div class="max_width_container">
      <breadcrumbs class=" " :items="items"></breadcrumbs>
      <v-row cols="12" class="ma-0 pa-0 mt-5" v-if="categoryCourse && categoryCourse.id">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="ma-0 pa-0">
          <div v-html="categoryCourse.descriptionHtml"></div>
        </v-col>
      </v-row>

      <v-row cols="12" class="ma-0 pa-0 mb-4" style="margin-top: -50px!important;">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="ma-0 pa-0">
          <v-btn
              class="float-right primary-button btn"
              elevation="0"
              :href="`${baseUrl}/cursos/combos/lista`"
          >
            Comprar Combo de Cursos
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <h2>
        Cursos em {{ categoryCourse.name }}
      </h2>
      <v-row cols="12" class="d-flex">
        <v-col class="filtes-content" cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <Filters
              @course="searchForCourseByName"
              @set-level="setLevel"
              @set-period="setPeriod"
              @selected-tags="selectedTags"
          ></Filters>
        </v-col>

        <v-col
            v-if="courses && courses.length > 0"
            class="pa-0 ma-0 "
            cols="12" xs="12" sm="12" md="12" lg="9" xl="9"
            style="margin-top: -20px!important;"
        >
          <div class="list-product-content">
            <div
                v-for="course in courses"
                class=" "
                :key="course.id"
            >
              <Course
                  style="height: 90%"
                  :key="`${course.productId}_course_`"
                  :course="course"
                  :showBtnBuy="true"
                  :showBtns="true"
              ></Course>
            </div>
          </div>

          <div class="ma-0 pa-0">
            <Pagination
                v-if="filter.totalItems > filter.pageSize"
                :currentPage="filter.currentPage"
                :totalItems="filter.totalItems"
                :page="filter.page"
                :pageSize="filter.pageSize"
                :totalPages="filter.totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </div>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="9" xl="9" class="text-center" v-else>
          <h2>Nenhum curso foi encontrado.</h2>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<style scoped>
.image-card-hover:hover {
  box-shadow: 10px 11px 13px rgba(0, 0, 0, 0.25) !important;
}

.max_width_container {
  width: 80% !important;
  margin: 0 10% 0 10%;
}
.btn {
  text-transform: none !important;
  font-size: 15px !important;
  margin-right: -2px !important;
}
@media (max-width: 1264px) {
  .max_width_container {
    width: 95% !important;
    margin: 0 2.5% 0 2.5%;
  }
}

.list-product-content {
  display: grid !important;
  gap: 10px;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
}

@media (max-width: 900px) {
  .list-product-content {
    grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  }
}

@media (max-width: 600px) {
  .list-product-content {
    grid-template-columns: repeat(auto-fill, minmax(90%, 1fr));
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Breadcrumbs from "../components/Breadcrumbs.vue";

import Vue from "vue";
import Course from "./Course.vue";
import Filters from "./Filters.vue";
import Pagination from "../../../components/base/Pagination.vue";

export default {
  name: "Category",
  components: {
    Pagination,
    Filters,
    Course,
    Breadcrumbs,
  },

  data: () => ({
    page: 1,
    totalPages: 15,
    totalItems: 0,
    componentKey: 1,
    isMobile: false,
    initalRange: 0,
    finalRange: 0,
    products: [],
    courses: [],
    subCategory: {},
    selected: null,
    env_url: "",
    apiService: new ApiService(),
    title: "",
    meta: [],
    filter: {
      pageSize: 10,
      currentPage: 0,
      page: 1,
      totalPages: 1,
      totalItems: 1,
      active: true,
      level: null,
      period: null,
      categoryCourse: null,
      tags: [],
      name: null,
    },
    items: [],
    categoryCourse: Object,
    category: null,
    baseUrl: null
  }),

  async mounted() {
    this.baseUrl = window.location.origin
    const {category} = this.$route.params
    this.category = category
    await this.getCategoryCourses()
    await this.paginatedList()
    this.items = [
      {
        text: "Página Inicial",
        disabled: true,
        href: "/home",
      },
      {
        text: "Cursos",
        disabled: true,
        href: "",
      },
      {
        text: "Categoria",
        disabled: true,
        href: "",
      },
      {
        text: this.categoryCourse.name,
        disabled: false,
        href: "",
      },
    ]
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {passive: true});
    }
    this.$root.$off("rechargeSubcategory")
  },


  computed: {},
  async created() {
  },

  watch: {},
  methods: {
    async backPage() {
      this.filter.page -= 1;
      await this.paginatedList();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.paginatedList();
    },
    async paginatedList() {
      try {
        this.filter.categoryCourse = this.categoryCourse.id
        const {items, pager} = await this.apiService.post("course/paginated", this.filter, false)
        this.courses = items
        this.filter.totalItems = pager.totalItems
        this.filter.currentPage = pager.currentPage
        this.filter.pageSize = pager.pageSize
        this.filter.totalPages = pager.totalPages
      } catch (e) {

      }
    },

    async searchForCourseByName(name) {
      this.filter.name = name
      this.filter.page = 1
      await this.paginatedList()
    },
    async setLevel(level) {
      this.filter.level = level
      this.filter.page = 1
      await this.paginatedList()
    },
    async setPeriod(period) {
      this.filter.period = period
      this.filter.page = 1
      await this.paginatedList()
    },
    async selectedTags(tags) {
      this.filter.tags = tags
      this.filter.page = 1
      await this.paginatedList()
    },
    async getCourses() {
      try {
        const {content} = await this.apiService.get(`course/active/b2c`,)
        this.courses = content
      } catch (e) {

      }
    },

    async getCategoryCourses() {
      try {
        const {content} = await this.apiService.get(`categoryCourses/linkSearch/${this.category}`)
        this.categoryCourse = content
      } catch (e) {

      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 600;
    },

    async goTo() {
      await this.$router.push({
        name: 'Combos',
      });
    },
  },
};
</script>
